export { VesselSource, VesselStatus, VesselType } from "../../graphql/generated";

import type { VesselBySlugQuery, VesselsListQuery } from "../../graphql/generated";

export type VesselListMember = VesselsListQuery["vessels"][number];
export type VesselDetail = NonNullable<VesselBySlugQuery["vesselBySlug"]>;
export type VesselDetailAssignment = VesselDetail["expeditionAssignments"][number];

export const TAB_FILTERS = ["all", "active", "under-maintenance", "retired"] as const;
export type TabFilter = (typeof TAB_FILTERS)[number];
